import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import CloudsFeed from "./components/CloudsFeed";
import BookmarkedClouds from "./components/BookmarkedClouds";
import PreloginPage from "./components/PreloginPage"
import BookmarkedArticles from "./components/BookmarkedArticles";
import ArticlesFeed from "./components/ArticlesFeed";
import Chat from "./components/Chat";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import Spinner from "./Spinner";
import registerServiceWorker from "./registerServiceWorker";
import firebase from "./firebase";
import BlogsFeed from "./components/BlogsFeed";

import ReportedClouds from "./components/AdminPages/ReportedClouds";
import ReportedArticles from "./components/AdminPages/ReportedArticles";

import "semantic-ui-css/semantic.min.css";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from "react-router-dom";

import { createStore } from "redux";
import { Provider, connect } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";
import { setUser, clearUser } from "./actions";
import {
  ROUTES_NAMES,
  LOGGED_IN_DISALLOWED_ROUTES,
  LOGGED_IN_ALLOWED_ROUTES,
  ADMIN_ROUTES,
} from "./routes";
import { isAdmin } from "./adminUsers";

const store = createStore(rootReducer, composeWithDevTools());

class Root extends React.Component {
  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log(user);

        this.props.setUser(user);

        if (
          LOGGED_IN_DISALLOWED_ROUTES.includes(this.props.location.pathname) ||           //if the route is not allowed after login
          !LOGGED_IN_ALLOWED_ROUTES.includes(this.props.location.pathname) ||              //if the route is invalid or not defined
          ((!isAdmin(user.email)) && ADMIN_ROUTES.includes(this.props.location.pathname))   //if the user is not admin and the routes is admin specific
        ) {
          this.props.history.push(ROUTES_NAMES.home);
        }
      } else {
        this.props.history.push(ROUTES_NAMES.preloginPage);
        this.props.clearUser();
      }
    });
  }

  render() {
    return this.props.isLoading ? (
      <Spinner />
    ) : (
      <Switch>
        <Route exact path={ROUTES_NAMES.preloginPage} component={PreloginPage} />
        <Route exact path={ROUTES_NAMES.app} component={App} />
        <Route exact path={ROUTES_NAMES.cloudsFeed} component={CloudsFeed} />
        <Route path={ROUTES_NAMES.login} component={Login} />
        <Route path={ROUTES_NAMES.register} component={Register} />
        <Route path={ROUTES_NAMES.articlesFeed} component={ArticlesFeed} />
        <Route path={ROUTES_NAMES.blogsFeed} component={BlogsFeed} />
        <Route path={ROUTES_NAMES.chat} component={Chat} />
        <Route path={ROUTES_NAMES.reportedClouds} component={ReportedClouds}/>
        <Route path={ROUTES_NAMES.reportedArticles} component={ReportedArticles}/>
        <Route path={ROUTES_NAMES.bookmarkedClouds} component={BookmarkedClouds}/>
        <Route path={ROUTES_NAMES.bookmarkedArticles} component={BookmarkedArticles}/>
      </Switch>
    );
  }
}

const mapStateFromProps = (state) => ({
  isLoading: state.user.isLoading,
  currentUser: state.user.currentUser,
});

const RootWithAuth = withRouter(
  connect(mapStateFromProps, { setUser, clearUser })(Root)
);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <RootWithAuth />
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js